const Extract = Symbol.for('react-wrap-with/Extract');

export default Extract;
